import { css } from 'aphrodite';
import * as React from 'react';
import { formatFileSize } from '../../../../utils/Support/supportHelpers';
import { Button } from '../../../../web/components-v2/Button';
import { CloseIcon, FileIcon } from './composerIcons';
import { composerStyles as styles } from './composerStyles';
import type { PendingAttachment } from './types';

interface ComposerAttachmentListProps {
	attachments: PendingAttachment[];
	onRemove: (id: string) => void;
}

/** Pending attachment rows with an indeterminate progress bar while a file uploads. */
export const ComposerAttachmentList: React.FC<ComposerAttachmentListProps> = ({ attachments, onRemove }) => {
	if (attachments.length === 0) return null;
	return (
		<div className={css(styles.attachmentList)}>
			{attachments.map(attachment => (
				<div key={attachment.id} className={css(styles.attachmentRow)}>
					<div className={css(styles.attachmentRowMain)}>
						<FileIcon />
						<span className={css(styles.attachmentName)}>{attachment.fileName}</span>
						<span className={css(styles.attachmentMeta)}>
							{attachment.uploading ? 'Uploading…' : formatFileSize(attachment.fileSize)}
						</span>
						{!attachment.uploading && (
							<Button
								variant='ghost'
								size='sm'
								styles={[styles.attachmentRemoveBtn]}
								onClick={() => onRemove(attachment.id)}
								title='Remove attachment'
								aria-label='Remove attachment'
							>
								<CloseIcon size={10} />
							</Button>
						)}
					</div>
					{attachment.uploading && <span className={css(styles.attachmentProgress)} />}
				</div>
			))}
		</div>
	);
};
